import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import React from "react";
import { useGetList } from "react-admin";

export const ALL_STATUSES = "ALL";

export const StatusFilterField = ({ value, onChange, label, filter, resource }) => {
	const handleChange = (e) => {
		onChange && onChange(e.target.value === ALL_STATUSES ? undefined : e.target.value);
	};

	const { ids, data } = useGetList(
		resource,
		{ page: 0, perPage: -1 },
		{ field: "id", order: "ASC" },
		filter
	);

	return (
		<TextField
			select
			label={label}
			variant="outlined"
			margin="none"
			size="small"
			value={value ?? ALL_STATUSES}
			onChange={handleChange}
			style={{ width: 200, marginLeft: 8 }}
		>
			<MenuItem value={ALL_STATUSES}>All</MenuItem>
			{ids.map((id) => (
				<MenuItem key={id} value={id}>
					{data[id].name}
				</MenuItem>
			))}
		</TextField>
	);
};
